import { useState, useEffect, useCallback } from "react";
import { apiService } from "../api/services/apiService";
import type { Link } from "../types";

export const useLinks = () => {
  const [links, setLinks] = useState<Link[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchLinks = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const linksData = await apiService.getLinks();
      setLinks(linksData); // TypeScript now knows this is Link[]
    } catch (err: any) {
      console.error(err);
      setError(err.message || "Failed to fetch links");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLinks();
  }, [fetchLinks]);

  return { links, loading, error, refresh: fetchLinks };
};
